<template>
  <v-dialog
    v-model="dialog"
    width="400px"
    @closed="closed">
    <div class="header flex">
      <p>{{title}}</p>
      <font-awesome-icon
        icon="times"
        class="close"
        @click="handleCancel"></font-awesome-icon>
    </div>
    <div class="body">
      <div class="main">
        <el-form
          ref="form"
          :model="formData">
          <div class="form-item">
            <span>Customer</span>
            <el-form-item>
              <v-input
                :value="customerName"
                disabled></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Content</span>
            <el-form-item prop="Content">
              <v-input
                v-model="formData.content"
                type="textarea"
                :rows="5"
              ></v-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="footer">
        <div class="btn flex">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <div>
            <v-button
              gray
              @click="handleSkip">skip</v-button>
            <v-button
              green
              @click="handleContinue">Continue</v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {sendUploadUser, sendUploadReferrer} from '@/api/share'
export default {
  name: 'BankTransferSms',
  props:{
    form:{
      type: Object,
      default: () => {}
    },
    isNewSME:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      dialog: false,
      formData:{
        content: '',
      },
      step: 1,
      isReject: false,
      rejectParams: {
        is_send: 0,
        content: '',
        referrer_is_send: 0,
        referrer_content: ''
      }
    }
  },
  computed:{
    title(){
      return this.step == 1? 'Send SMS to Client' : 'Send SMS to Referrer'
    },
    customerName(){
      let {referrer} = this.form||{}
      let {identity,isrd_com_nm,isrd_lst_nm,isrd_fst_nm,isrd_nm} = referrer||{}
      let name = identity==2?isrd_com_nm:`${isrd_lst_nm||''} ${isrd_fst_nm||''}`
      if(this.isNewSME)
        return this.step == 1? this.form.contact_nm : isrd_nm
      return this.step == 1? this.form.customer.nick_name : isrd_nm
    }
  },
  watch:{
    dialog:{
      immediate: true,
      handler(val){
        let {send_reject_message} = this.form
        let {contact_data={},referrer_data={}} =send_reject_message||{}
        if(val){
          this.formData.content = this.isNewSME?contact_data:this.form.share_guest_user_data.url_data
        }
        if(this.isReject){
          this.formData.content = this.isNewSME?referrer_data:this.form.share_guest_reject_user_data.url_data
        }
      }
    }
  },
  methods: {
    changeDialog(type){
      this.isReject = type == 'reject'
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.changeDialog()
    },
    handleContinue(){
      let params = {
        is_send: 1,
        content: this.formData.content,
        order_id: this.form.id
      }
      let {send_reject_message} = this.form
      let {contact_data,referrer_data} =send_reject_message
      if(this.isReject){
        if(this.step == 1){
          this.rejectParams.is_send = 1
          this.rejectParams.content = this.formData.content
          this.formData.content = this.isNewSME?referrer_data:this.form.share_guest_reject_referrer_data.url_data
          this.step = 2
        }else{
          this.rejectParams.referrer_is_send = 1
          this.rejectParams.referrer_content = this.formData.content
          this.$emit('getResult', this.rejectParams)
        }
      }else{
        if(this.step == 1){
          this.network().sendUploadUser(params)
        }else{
          this.network().sendUploadReferrer(params)
        }
      }
    },
    handleSkip(){
      let {send_reject_message} = this.form
      let {contact_data,referrer_data} =send_reject_message
      if(this.isReject){
        if(this.step == 1){
          this.rejectParams.is_send = 0
          this.rejectParams.content = this.formData.content
          this.formData.content = this.isNewSME?referrer_data:this.form.share_guest_reject_referrer_data.url_data
          this.step = 2
        }else{
          this.rejectParams.referrer_is_send = 0
          this.rejectParams.referrer_content = this.formData.content
          this.$emit('getResult', this.rejectParams)
        }
      }else{
        if(this.step == 1){
          this.step = 2
        }else{
          this.changeDialog()
        }
      }
    },

    closed(){
      this.step = 1
    },

    network(){
      return {
        sendUploadUser: async(params) =>{
          const {data} = await sendUploadUser(params)
          let {send_reject_message} = this.form
          let {contact_data,referrer_data} =send_reject_message
          if(data.code == 1000){
            this.formData.content = this.isNewSME?referrer_data:this.form.share_guest_referrer_data.url_data
            this.step = 2
          }
        },
        sendUploadReferrer: async(params) => {
          const {data} = await sendUploadReferrer(params)
          if(data.code == 1000){
            this.changeDialog()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .body{
    padding: 20px 15px 15px 15px;
    .footer{
      margin-top: 20px;
      .btn{
        justify-content: space-between;
      }
    }
  }
}
</style>
